<template>
  <div>
    <h2 class="mb-4 text-left font-weight-bold">Checklists</h2>
    <b-row class="wiki-main-wrap">
      <div class="tags-main-wrap">
        <section class="widget">
          <div class="text-center">
            <router-link :to="{ path: `/app/checklists/`}">
              <button type="button" class="btn mr-xs btn-success new-page-btn">
                View All Checklists
              </button>
            </router-link>
          </div>
          <div class="text-center">
            <button type="button" class="btn mr-xs btn-success new-page-btn" @click="gotoCreatePage()">
              <i class="fa fa-plus" aria-hidden="true"></i>Create a Checklist
            </button>
          </div>
        </section>
      </div>
      <div class="table-main-wrap">
        <section class="widget">
          <b-row>
            <b-col xl="5" lg="6" sm="12">
              <p class="search-text">Search Here:</p>
              <b-form-group>
                <b-input-group>
                  <b-form-input id="search-field" v-model="searchTerm" type="text" @keyup.enter="search"></b-form-input>
                  <b-input-group-append>
                    <b-btn variant="success" @click="search">Search</b-btn>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col sm="12">
              <ErrorDisplay/>
              <div v-if="this.checklists && this.checklists.length === 0">
                <span>No Checklists found</span>
                <span v-if="searchTerm"> that matches the search!</span>
              </div>
              <div class="table-responsive mt-3" v-if="this.checklists && this.checklists.length > 0">
                <table class="table table-hover">
                  <thead>
                    <tr>
                      <th>Name</th>                      
                      <th>Last Modified</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(checklist,index) in this.checklists" :key="index">
                      <!-- <td @click="gotoViewPage(page.wikiPageID)"> -->
                      <td>
                        <div class="text-title-wrap">
                        <i class="fa fa-file-text-o" aria-hidden="true"></i>
                          <router-link :to="{ name: 'ViewChecklist', params: {checklistID:  `${checklist.ChecklistID}`} }">{{checklist.Name}}</router-link>
                        </div>
                      </td>                      
                      <td>{{checklist.CreatedAt | dateformat(dateFormatStr)}}</td>
                      <td>
                        <!-- <span class="glyphicon glyphicon-edit" @click="showModal('edit', page.WikiPageID)"/> -->
                        <span class="glyphicon glyphicon-trash" @click="showModal('delete', checklist.ChecklistID)" v-if="$can('delete',checklist)"/>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </b-col>
          </b-row>
        </section>
      </div>
    </b-row>
  </div>
</template>

<script>
/* eslint-disable */
import { mapState, mapActions, mapMutations } from 'vuex';
import ErrorDisplay from "@/components/ErrorDisplay/ErrorDisplay";
import mixin from '../../mixin.js';

export default {
  name: "Checklists",
  components: { ErrorDisplay },
  props: ['searchTerm'],
  mixins: [mixin],

  created() {
    this.init();
  },

  data() {
    return {
      editors: [],
      selectedWikiPageID: 0,
      allCanView: false,
      allCanEdit: false,
      simpleDropdownVariant: "Select",
      isPickerActive: false
    };
  },
  methods: {
    ...mapActions('checklists', ['getChecklists', 'deleteChecklist']),

    async init() {
      await this.getChecklists({siteID: this.siteID});
    },

    search() {
      this.init();
    },

    showModal(name, wikiPageID) {
      this.selectedWikiPageID = wikiPageID;
      this.$refs[name].show();
    },

    hideModal(ref) {
      this.$refs[ref].hide()
    },

    gotoCreatePage() {
      this.$router.push({
        name: 'CreateChecklist',
        params: {
          checklists : this.checklists
        }
      });
    },

    gotoViewPage(checklistID) {
        this.$router.push({
        name: 'ChecklistView',
        params: {
          checklistID : checklistID
        }
      });
    },

    async del() {
      try {
        this.hideModal('delete');
        await this.deleteChecklist({ChecklistID: this.selectedChecklistID});        
        this.$router.go(0);
      } catch(e) {
        console.log('Error' + e);
      }
    }
  },

  computed: {
    ...mapState({
        checklists: state => state.checklists.checklists,
    }),
  }

};
</script>
